module.exports = __webpack_public_path__ + "static/media/stadium_euro.6c7298e3.webp";